// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './vuex/store'
import VueCurrencyInput from 'vue-currency-input'

window.$ = window.jQuery = require('jquery')
window.$toast = require('toastr')
require('bootstrap-sass')
import 'font-awesome/css/font-awesome.css'
Vue.config.productionTip = false

Vue.use(VueCurrencyInput)

Vue.filter('limit', function (item) {
  var count = 30
  return item.slice(0, count) + (item.length > count ? '...' : '')
})

Vue.filter('limit100', function (item) {
  var count = 100
  return item.slice(0, count) + (item.length > count ? '...' : '')
})

Vue.filter('two_decimal', function (item) {
  return parseFloat(item).toFixed(2)
})

Vue.filter('number', function (item) {
  if (item != undefined && !isNaN(item)) {
    return new Intl.NumberFormat('de-DE').format(item)
  } else {
    return '0'
  }
})

$(function () {
  $('body').tooltip({
    selector: '[data-toggle="tooltip"]',
  })
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js